import * as Actions from '../../actions/settings/type';

const initialState = {
  loading: false,
  createLoader: false,
  allSettingsList: [],
  error: '',
  userNotifications: [],
  setSettings: null,
};
const settingReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Toggle Settings
    case Actions.GET_TOGGLE_SETTINGS_REQUEST:
      return {
        ...state,
        getToggleSettingsLoading: true,
      };
    case Actions.GET_TOGGLE_SETTINGS_SUCCESS:
      return {
        ...state,
        getToggleSettingsLoading: false,
        toggleSettings: action?.payload?.data || '',
      };
    case Actions.GET_TOGGLE_SETTINGS_FAIL:
      return {
        ...state,
        getToggleSettingsLoading: false,
        getToggleSettingsError: action.payload,
      };

    // Update Toggle Settings
    case Actions.UPDATE_TOGGLE_SETTINGS_REQUEST:
      return {
        ...state,
        updateToggleSettingsLoading: true,
      };
    case Actions.UPDATE_TOGGLE_SETTINGS_SUCCESS:
      return {
        ...state,
        updateToggleSettingsLoading: false,
        toggleSettings: action?.payload?.data || '',
      };
    case Actions.UPDATE_TOGGLE_SETTINGS_FAIL:
      return {
        ...state,
        updateToggleSettingsLoading: false,
        updateToggleSettingsError: action.payload,
      };
    case Actions.CLEAR_UPDATE_TOGGLE_SETTINGS:
      return {
        ...state,
        updateToggleSettingsLoading: false,
        toggleSettings: '',
        updateToggleSettingsError: '',
      };

    // Get Notifications settings
    case Actions.GET_NOTIFICATION_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.GET_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        allSettingsList: action?.payload?.data || '',
      };
    case Actions.GET_NOTIFICATION_SETTINGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Create user setting
    case Actions.SET_USER_NOTIFICATION_SETTINGS_REQUEST:
      return {
        ...state,
        createLoader: true,
      };
    case Actions.SET_USER_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        createLoader: false,
        setSettings: action?.payload || '',
      };
    case Actions.SET_USER_NOTIFICATION_SETTINGS_FAIL:
      return {
        ...state,
        createLoader: false,
        error: action.payload,
      };

    // Get  user notifications
    case Actions.GET_USER_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.GET_USER_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        userNotifications: action?.payload?.data || '',
      };
    case Actions.GET_USER_NOTIFICATIONS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case Actions.UPDATE_NOTIFICATIONS_LIST:
      return {
        ...state,
        userNotifications: [],
      };

    case Actions.CLEAR_SET_NOTIFICATION_STATES:
      return {
        ...state,
        setSettings: null,
      };

    default:
      return state;
  }
};

export default settingReducer;
